import React from "react";
import Spool from "./Spool";

export default function Spools({
  progress = 0,
  totalRotations = 0,
  timings,
  isTransparent,
}) {
  const maxRadius = 42;
  const minRadius = 20;
  const range = maxRadius - minRadius;
  const currRightRadius = minRadius + range * progress;
  const currLeftRadius = maxRadius - range * progress;

  let maxRotation = totalRotations * 360;

  return (
    <>
      <Spool
        isTransparent={isTransparent}
        tapeRadius={currLeftRadius}
        progress={progress}
        maxRotation={-maxRotation}
        timings={timings}
      />
      <g transform={`translate(115, 0)`}>
        <Spool
          isTransparent={isTransparent}
          tapeRadius={currRightRadius}
          progress={progress}
          maxRotation={-maxRotation}
          timings={timings}
        />
      </g>
    </>
  );
}
